export const environment = {
  appVersion: '1.1.0.36580',
  production: true,
  //api:
  apiUrl: '/api',
  apiVersion: '1.0',
  appInsightsConnectionString: 'InstrumentationKey=dcdea81e-20a8-4152-8528-c6c95f83d0ae;IngestionEndpoint=https://northcentralus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://northcentralus.livediagnostics.monitor.azure.com/;ApplicationId=f08a8ff5-f230-4a7a-9c72-29c20920787d',
  //Okta:
  clientId: '0oa6i7zzsyImLJxiE697',
  issuer: 'https://crb-viewaccount.okta.com/oauth2/aus6kdb4tg0mJ9poj697',
  scopes: ['openid', 'profile', 'email'],
  pkce: true,

  // Google Analytics
  measurementId: 'G-KX878ETH28',

  //Space Chat
  spaceChat: 'https://dgdefljyz5n4y.cloudfront.net/scripts/ChatModule_c_u.js',
  spaceAuthenticatedChat: 'https://dgdefljyz5n4y.cloudfront.net/scripts/ChatModule_c_a.js',

  //Slider
  sliderDelay: 5000,
  //Aeropay legal documents
  aeropayTermsOfServiceUrl: 'https://www.aeropay.com/legal/terms-of-service---end-user',
  aeropayPrivacyPolicyUrl: 'https://www.aeropay.com/legal/privacy-policy',

  cRBTestDomain: '',
}
